import React from 'react';

const StatusDisplay = ({ isLoading, verificationStatus }) => {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-12">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-lg text-gray-700 font-medium">Verifica metodo di pagamento in corso…</p>
      </div>
    );
  }

  const statusConfig = {
    pending: {
      emoji: '⏳',
      text: 'Verifica metodo di pagamento in attesa',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-300',
      textColor: 'text-yellow-800'
    },
    verified: {
      emoji: '✅',
      text: 'Metodo di pagamento verificato con successo',
      bgColor: 'bg-green-50',
      borderColor: 'border-green-300',
      textColor: 'text-green-800'
    },
    failed: {
      emoji: '❌',
      text: 'Verifica metodo di pagamento non riuscita',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-300',
      textColor: 'text-red-800'
    }
  };

  const config = statusConfig?.[verificationStatus] || statusConfig?.pending;

  return (
    <div
      className={`${config?.bgColor} ${config?.borderColor} border-2 rounded-lg p-6 text-center`}
    >
      <div className="text-5xl mb-4">{config?.emoji}</div>
      <p className={`text-lg font-semibold ${config?.textColor}`}>
        {config?.text}
      </p>
    </div>
  );
};

export default StatusDisplay;